export function registerBreadcrumbs(ctx, values) {
    ctx.dispatch((state) => ({
        ...state,
        registry: {
            ...state.registry,
            breadcrumbs: {
                ...state.registry.breadcrumbs,
                ...values,
            },
        },
    }));
}
export function unregisterBreadcrumbs(ctx, names) {
    ctx.dispatch((state) => ({
        ...state,
        registry: {
            ...state.registry,
            breadcrumbs: names.reduce((prev, name) => {
                const { [name]: _, ...rest } = prev;
                return rest;
            }, state.registry.breadcrumbs),
        },
    }));
}
//# sourceMappingURL=actions.js.map